import type { ComponentProps } from 'react';
import { Typography } from '@fiverr-private/typography';

interface GetReviewsSnippetButtonTypographyPropsArgs {
    isProRebrandingLayout: boolean;
}

export const getReviewsSnippetButtonTypographyProps = ({
    isProRebrandingLayout,
}: GetReviewsSnippetButtonTypographyPropsArgs): ComponentProps<typeof Typography> => ({
    fontSize: 'b_sm',
    ...(isProRebrandingLayout && {
        color: 'grey_1200',
        fontWeight: 'semibold',
        fontSize: 'b_md',
    }),
});
